import styles from "./WhyWaterless.module.css";

const comparisonRows = [
  {
    label: "צריכת מים",
    regular: "1–3 ליטר בכל שטיפה",
    waterless: "0 ליטר — חיסכון עד 100,000 ל'/שנה",
  },
  {
    label: "ריחות",
    regular: "מים עומדים שמגדלים חיידקים",
    waterless: "סיפון BlueSeal חוסם ריחות הרמטית",
  },
  {
    label: "חשמל וחיישנים",
    regular: "שסתום/חיישן שמתקלקלים",
    waterless: "ללא חשמל כלל — אמינות מלאה",
  },
  {
    label: "כשרות לשבת",
    regular: "תלוי בחיישן/מנגנון חשמלי",
    waterless: "כשר לשבת — פעולה מכנית בלבד",
  },
  {
    label: "כימיקלים",
    regular: "דורש חומרי ניקוי חזקים",
    waterless: "נוזל איטום ביולוגי מתכלה",
  },
  {
    label: "תחזוקה",
    regular: "סתימות, אבנית ותיקוני צנרת",
    waterless: "מינימלית — החלפת מחסנית פשוטה",
  },
  {
    label: "השפעה סביבתית",
    regular: "בזבוז מים ואנרגיה",
    waterless: "פתרון ירוק, ניקוד LEED ותקן 5281",
  },
];

const WhyWaterless = ({ onCtaClick }) => {

  return (
    <section
      className={styles.section}
      aria-labelledby="whyWaterlessTitle"
    >
      <div className="container-fluid px-3 px-md-5">
        <div className={styles.header}>
          <span className={styles.eyebrow}>השוואה תפעולית</span>
          <h2 id="whyWaterlessTitle" className={styles.title}>
            משתנה רגילה מול משתנה ללא מים
          </h2>
          <p className={styles.subtitle}>
            השוו את צריכת המים, התחזוקה והדרישות התפעוליות.
          </p>
        </div>

        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <caption className={styles.visuallyHidden}>
              השוואה בין משתנה רגילה למשתנה ללא מים של Waterless
            </caption>
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">
                  משתנה רגילה
                </th>
                <th scope="col" className={styles.thWaterless}>
                  משתנה Waterless
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonRows.map((row) => (
                <tr key={row.label}>
                  <th scope="row" className={styles.rowLabel}>
                    {row.label}
                  </th>
                  <td className={styles.cellRegular}>
                    <span
                      className={`iconify ${styles.iconNo}`}
                      data-icon="mdi:close-circle"
                      aria-hidden="true"
                    ></span>
                    {row.regular}
                  </td>
                  <td className={styles.cellWaterless}>
                    <span
                      className={`iconify ${styles.iconYes}`}
                      data-icon="mdi:check-circle"
                      aria-hidden="true"
                    ></span>
                    {row.waterless}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className={styles.ctaRow}>
          <button
            type="button"
            className={styles.cta}
            onClick={onCtaClick}
            aria-label="בקשת הצעת מחיר"
          >
            בקשת הצעת מחיר
          </button>
          <span className={styles.ctaNote}>
            שירות וחלקים בישראל
          </span>
        </div>
      </div>
    </section>
  );
};

export default WhyWaterless;
